import { render } from "./index.vue?vue&type=template&id=2a3c060b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2a3c060b&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3c060b"],['__file',"src/views/vab/richTextEditor/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a3c060b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a3c060b', __exports__)) {
    console.log('reload')
    api.reload('2a3c060b', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2a3c060b&scoped=true", () => {
    console.log('re-render')
    api.rerender('2a3c060b', render)
  })

}


export default __exports__